import parseLatex from './parseLatex';
import React from 'react';

function Container(tag){
  return { tag, children:[] }
}

export function RenderObject({text,tags}){

  let stack = [{tag:"span",children:[]}];

  const peek = () => stack.slice(-1)[0];

  

  Array.from(text).forEach((child,ii) => {

    let curContainer = peek();

    let change = tags[ii];
    let {skip,s,e} = change || {};
    

    if( change ){
    if( s?.tags ){
      s.tags.forEach(tag => {
        let newContainer = Container(tag)
        peek().children.push(newContainer);
        stack.push(newContainer);
      })
    }else if( e?.tags ){

      e.tags.forEach(tag => {
        if( tag !== peek().tag ){
          console.error("TAG MISMATCH WHEN ENDING!");
          throw Error("TAG MISMATCH");
        }else{
          stack.pop();
        }

      })

    }
    }

    if( change && skip ){
      return;
    }

    peek().children.push(child);



  })


  const toComp = list => {
    return list.map(el => {
      if( typeof(el) === typeof("") ){
        return <span>{el}</span>
      }else{
        let { tag, children } = el;
        return React.createElement(tag, {
          children:toComp(children)
        })
      }
    })
  }
  

  return { json:stack, component:toComp([stack[0]]) };



}


export default function BaselineRenderer({cellLocation, line, text}){

  let tags = parseLatex(text||"") 

  return RenderObject({...{text,tags}}).component;


}
